import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lock-screen',
  templateUrl: './lock-screen.component.html'
})
export class LookScreen implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/authentication/lock-screen/lock-screen.component.ts